
export const getLocalizedTaxonomyLabel = (i18nContext, taxonomyTermId: string, fallback: string): string => {
    const key = `facet.${taxonomyTermId}`
    const localized = i18nContext.get(key)
    if (localized && localized !== key) {
        return localized
    }
    return fallback
}